export const FILTER_BROWSABLE = 'browsable';

export const DEFAULT_PAGE_SIZES = [10, 50, 100];
